<template>
  <div :class="{'hidden':hidden}" class="pagination-container">
    <el-pagination
      :background="background"
      :current-page="currentPage"
      :page-size="currentPageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { scrollTo } from '@/utils/scroll-to'

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    pageNo: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50]
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentPage: this.pageNo,
      currentPageSize: this.pageSize
    }
  },
  watch: {
    pageNo(newVal) {
      this.currentPage = newVal
    },
    pageSize(newVal) {
      this.currentPageSize = newVal
    }
  },
  methods: {
    handleSizeChange(pageSize) {
      this.currentPageSize = pageSize
      this.$emit('pagination', { pageNo: this.currentPage, pageSize: pageSize })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleCurrentChange(pageNo) {
      this.currentPage = pageNo
      this.$emit('pagination', { pageNo: pageNo, pageSize: this.currentPageSize })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    }
  }
}
</script>

<style scoped>
.pagination-container {
  background: #fff;
  padding: 32px 16px;
  text-align: right;
}
.pagination-container.hidden {
  display: none;
}
/* ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #60B7DC;
} */
::v-deep .el-pagination {
  font-weight: normal;
}
</style>
